import { Component, Injector, OnInit } from '@angular/core';
import { ModalComponent } from '../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-logout-timeout-modal',
  templateUrl: './logout-timeout-modal.component.html',
  styleUrls: ['./logout-timeout-modal.component.scss'],
  standalone: false,
})
export class LogoutTimeoutModalComponent implements OnInit {
  public isHttpError: boolean;

  private modalComponent: any;

  constructor(private _inj: Injector) {
    this.modalComponent = this._inj.get(ModalComponent);
    this.isHttpError =
      this.modalComponent &&
      this.modalComponent.data &&
      this.modalComponent.data.isHttpError
        ? true
        : false;
  }

  ngOnInit() {}

  public accept() {
    this.modalComponent.accept();
  }
}
